import { PropsWithChildren } from 'react'

import { inputId } from 'aem-libs-tests/src/constants/inputId'
import { createTestId } from 'aem-libs-tests/src/utility/createTestId'

import * as InputStyles from './input.styled'
import { Label, LabelProps } from './label'


export const CommonInputWrapper = ({
  children,
  className,
  testId,
  id,
  ...labelProps
}: PropsWithChildren<LabelProps>) => {
  return (
    <InputStyles.Container
      className={className}
      id={'common-input-wrapper'}
      data-testid={createTestId(testId ?? 'input-wrapper', inputId.wrapper)}
    >
      <Label htmlFor={id} id={`${id}-label`} testId={testId} {...labelProps} />
      {children}
    </InputStyles.Container>
  )
}
